import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getFirestore, collection, addDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import { app } from '../firebase';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const db = getFirestore(app);

export default function DomainForm() {
    const { id } = useParams();
    const isEdit = !!id;
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(isEdit);

    useEffect(() => {
        if (!isEdit) return;
        setLoading(true);
        const ref = doc(db, 'domains', id);
        getDoc(ref).then(snap => {
            if (!snap.exists()) {
                alert('Domain not found');
                navigate('/domains');
                return;
            }
            const data = snap.data();
            setName(data.name || '');
        }).catch(e => console.error('fetch domain', e)).finally(() => setLoading(false));
    }, [id, isEdit, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEdit) {
                await updateDoc(doc(db, 'domains', id), { name });
            } else {
                await addDoc(collection(db, 'domains'), { name });
            }
            navigate('/domains');
        } catch (e) {
            console.error('save domain', e);
            alert('Failed to save domain');
        }
    };

    if (loading) return <Box sx={{ p: 2 }}>Loading domain...</Box>;

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5">{isEdit ? 'Edit Domain' : 'Create Domain'}</Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField label="Name" value={name} onChange={e => setName(e.target.value)} required />
                <Box>
                    <Button type="submit" variant="contained">Save</Button>
                    <Button type="button" variant="outlined" onClick={() => navigate('/domains')} sx={{ ml: 1 }}>Cancel</Button>
                </Box>
            </Box>
        </Box>
    );
}
